module.exports = __webpack_public_path__ + "img/playing-cards_free_background_image_2210x1473.e82ae83a.jpg";